import { useState } from '#imports'
import { onMounted } from 'vue'
import type { LocationQuery } from 'vue-router'

import type { GetOfferV1Response } from '@backmarket/nuxt-layer-buyback/app/scopes/offer/api/types'
import { useLocalStorage } from '@backmarket/utils/composables/useLocalStorage'

export function useBuybackFunnelOffer() {
  const offer = useState<GetOfferV1Response | null>(
    'buyback-funnel-offer',
    () => null,
  )
  const offerPayload = useState<LocationQuery | null>(
    'buyback-funnel-offer-payload',
    () => null,
  )
  const localStorage = useLocalStorage()

  function resetBuyBackOffer() {
    offer.value = null
    offerPayload.value = null
    localStorage.removeItem('buyback_offer')
    localStorage.removeItem('buyback_offer_payload')
  }

  function setBuyBackOffer(
    newOffer: GetOfferV1Response,
    payload: LocationQuery,
  ) {
    offer.value = newOffer
    offerPayload.value = payload

    localStorage.setItem('buyback_offer', JSON.stringify(newOffer))
    localStorage.setItem('buyback_offer_payload', JSON.stringify(payload))
  }

  onMounted(() => {
    const storedOffer = localStorage.getItem('buyback_offer')
    const storedPayload = localStorage.getItem('buyback_offer_payload')

    offer.value = storedOffer ? JSON.parse(storedOffer) : null
    offerPayload.value = storedPayload ? JSON.parse(storedPayload) : null

    // !offer.value.listing is a temporary fix to prevent the offer page from showing
    // when customer has legacy offer in local storage
    if (offer.value && !offer.value.listing) {
      resetBuyBackOffer()
    }
  })

  return {
    offer,
    offerPayload,
    resetBuyBackOffer,
    setBuyBackOffer,
  }
}
